export const TEAM_SEATS_OPTIONS = [
  { label: '2 seats', value: 2 },
  { label: '3 seats', value: 3 },
  { label: '4 seats', value: 4 },
  { label: '5 seats', value: 5 },
  { label: '6 seats', value: 6 },
  { label: '7 seats', value: 7 },
  { label: '8 seats', value: 8 },
  { label: '9 seats', value: 9 },
  { label: '10 seats', value: 10 },
  { label: '11 seats', value: 11 },
  { label: '12 seats', value: 12 },
  { label: '13 seats', value: 13 },
  { label: '14 seats', value: 14 },
  { label: '15 seats', value: 15 },
  { label: '16 seats', value: 16 },
  { label: '17 seats', value: 17 },
  { label: '18 seats', value: 18 },
  { label: '19 seats', value: 19 },
  { label: '20 seats', value: 20 },
]

export const TEAM_SEATS_OPTIONS_VALUES = TEAM_SEATS_OPTIONS.map(
  (option) => option.value,
)
